import React from 'react';
import ReactDOM from 'react-dom';
/*@begin-app-target*/import { App } from './app';/*@end-app-target*/
import { mergeStyles, createTheme, loadTheme } from '@fluentui/react';
import reportWebVitals from './reportWebVitals';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import { fontFamily, palette, fonts } from './app/app-theme';

initializeIcons();

// Inject some global styles
mergeStyles({
  ':global(body,html,#root)': {
    margin: 0,
    padding: 0,
    height: '100vh',
    'font-family': fontFamily,
    'font-size': '16px',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
  },
  // hack to fix broken Fluent UI component...
  ':global(.ms-DatePicker-goToday)': {
    right: 13,
  },
  // override button heights
  ':global(.ms-Button)': {
    height: '2.5em !important',
  },
  // fix layout of modal/panel dialogs on small screens
  ':global(.ms-Layer--fixed)': {
    maxWidth: '100vw',
    maxHeight: '100vh',
  },
});

// set color scheme
const theme = createTheme({ palette, fonts });
loadTheme(theme);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
